import { ref } from "vue";
import { getAllTeams, getTeamById, addTeam, updateTeam, deleteTeam, assignUserToTeam, getTeamMembers, removeUserFromTeam } from "../../api/teams";

const state = {
    teams: ref([]),
    team: ref({}),
    members: ref([]),
    isLoading: ref(false),
    usersToAssign: ref([]),
};

const actions = {
    /**
     * جلب جميع الفرق
     */
    async fetchTeams({ commit }, page) {
        try {
            const response = await getAllTeams(page);
            commit('SET_TEAMS', response.teams);
            commit('SET_USERS', response.usersToAssign);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * جلب فريق معين حسب الـ ID
     */
    async fetchTeamById({ commit }, id) {
        try {
            const response = await getTeamById(id);
            commit('SET_TEAM', response.data);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * إنشاء فريق جديد
     */
    async addNewTeam({ commit }, team) {
        try {
            const response = await addTeam(team);
            commit('ADD_TEAM', response.data.team);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * تحديث بيانات فريق معين
     */
    async updateTeam({ commit }, team) {
        try {
            const response = await updateTeam(team.id, team);
            commit('UPDATE_TEAM', response.data.team);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * حذف فريق
     */
    async deleteTeam({ commit }, id) {
        try {
            await deleteTeam(id);
            commit('DELETE_TEAM', id);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * تعيين مستخدم إلى فريق
     */
    async assignUserToTeam({ commit }, data) {
        try {
            await assignUserToTeam(data);
            commit('ADD_MEMBER', userId);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * جلب أعضاء الفريق
     */
    async fetchTeamMembers({ commit }, teamId) {
        try {
            const response = await getTeamMembers(teamId);
            
            commit('SET_MEMBERS', response.members);
            commit('SET_TEAM', response.team);
            commit('SET_USERS', response.usersToAssign);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * إزالة مستخدم من الفريق
     */
    async removeUserFromTeam({ commit }, { teamId, userId }) {
        try {
            await removeUserFromTeam(teamId, userId);
            commit('REMOVE_MEMBER', userId);
        } catch (error) {
            console.log(error);
        }
    },
};

const mutations = {
    SET_USERS(state,users){
        state.usersToAssign = users;
    },
    SET_TEAMS(state, teams) {
        state.teams = teams;
    },
    SET_TEAM(state, team) {
        state.team = team;
    },
    ADD_TEAM(state, team) {
        state.teams.unshift(team);
    },
    UPDATE_TEAM(state, updatedTeam) {
        state.teams = state.teams.map(team => team.id === updatedTeam.id ? updatedTeam : team);
    },
    DELETE_TEAM(state, id) {
        state.teams = state.teams.filter(team => team.id !== id);
    },
    SET_MEMBERS(state, members) {
        state.members = members;
    },
    ADD_MEMBER(state, userId) {
        state.members.push(userId);
    },
    REMOVE_MEMBER(state, userId) {
        state.members = state.members.filter(member => member.id !== userId);
    },
};

const getters = {
    getTeams: (state) => state.teams,
    getTeam: (state) => state.team,
    getMembers: (state) => state.members,
    getUsersToAssign: (state) => state.usersToAssign,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
